export default __webpack_public_path__ + "static/media/sm_transp_mini.f19383a2.png";